<script lang="tsx" setup>
import { useRecorderFlow } from 'ui'
import { useForm } from '../state'
import Form from './Form.vue'
import Player from './Player.vue'

const { mic, strings, state } = useForm()
const showMessageMode = ref(false)

const recorder = useRecorderFlow({
  onError(error) {
    console.error('Error occurred in recorder flow\n\n', error)
    showMessageMode.value = true
  }
})

async function record() {
  const success = await mic.request()

  if (success)
    await recorder.start()
  else showMessageMode.value = true
}

async function finish() {
  state.audio = await recorder.finish()
}

onBeforeMount(() => {
  // Auto start if permission is given
  if (mic.state === 'granted')
    record()
})

// Save audio before unmount
onBeforeUnmount(finish)
</script>

<template>
  <div>
    <section class="card flex-col-center">
      <!-- Audio Player -->
      <Player v-if="!!state.audio" :result="state.audio" />

      <!-- Text Fallback -->
      <template v-else-if="showMessageMode">
        <h3 class="w-full text-lg text-left font-medium" v-text="strings.fallbackMessageTitle" />

        <textarea
          v-model="state.message"
          name="message"
          :placeholder="strings.fallbackInputPlaceholder"
          class="card-outline bg-$color-background w-full flex-grow resize-none outline-none"
          required
        />
      </template>

      <!-- Recorder -->
      <template v-else>
        <h3 class="leading-none text-64px sm:mb-6 sm:text-96px" :class="recorder.state.recording && 'text-$color-primary'">
          {{ recorder.timer.formatted.value }}
        </h3>

        <CTAButton v-if="!recorder.state.recording" aria-label="Start Recording" @resolve-click="record">
          <Icon name="solar:record-bold" />
          {{ strings.startRecording }}
        </CTAButton>

        <CTAButton v-else aria-label="Stop Recording" @resolve-click="finish">
          <Icon name="solar:stop-bold" />
          {{ strings.stopRecording }}
        </CTAButton>
      </template>
    </section>

    <Form />
  </div>
</template>
